import { purifyPayloadForBasicInformation } from '../../Utils/purifyPayload';
import type { CollectorSelfProfileOptions } from './collectorSelfProfileOptions';
import { client } from '../client';
import { BasicInfo, UserProfile, UserRoleName } from './types/UserProfile';

export const createBasicInformation = async (
  payload: BasicInfo,
  user_id: number,
  userRole?: string,
  options?: CollectorSelfProfileOptions,
): Promise<UserProfile> => {
  const isAdminRole =
    userRole === UserRoleName.Admin ||
    userRole === UserRoleName.SuperAdmin ||
    userRole === UserRoleName.OrganizationAdmin;
  const prefix =
    userRole === UserRoleName.CareAdvisor
      ? '/care_advisor'
      : userRole === UserRoleName.Collector
        ? '/collector'
        : isAdminRole
          ? '/admin'
          : '';
  const useCollectorMe =
    userRole === UserRoleName.Collector && options?.collectorEditingSelf === true;
  const purifiedPayload = purifyPayloadForBasicInformation(payload);

  const url = useCollectorMe ? '/collector/me/basic_info' : `${prefix}/users/${user_id}/basic_info`;
  const { data } = await client.post<UserProfile>(url, purifiedPayload);

  return data;
};
